import CollectionList from "@/js/Shared/Collections/CollectionList";

export {ContactsDuplicatesCollection as default}

class ContactsDuplicatesCollection{
  /**
   * Contact list
   *
   * @type {Object.<ContactsCollection>}
   */
  contacts_list;

  /**
   * duplicate counter
   *
   * @type {Number}
   */
  count = 0;

  /**
   * Stores by index the emails that contain duplicates
   *
   * @type {Object.<CollectionList>}
   */
  duplicates = {};

  /**
   * Stores the email that was selected to correct
   *
   * @type {String}
   */
  email_selected;

  /**
   * Set a list of contacts
   *
   * @param {Object.<ContactsCollection>} contacts
   */
  setContactsList(contacts){
    this.contacts_list = contacts;
  }

  /**
   * Search and catch duplicate emails
   *
   * @returns {void}
   */
  findDuplicates(){
    if(!this.contacts_list.count){
      return;
    }

    this.duplicates = this.createDuplicatesList();
    this.removeNonDuplicates();
  }

  /**
   * Creates the list of duplicate emails taking into account
   * consideration as index the email
   *
   * @returns {Object}
   */
  createDuplicatesList() {
    return this.contacts_list.items.reduce((acc, contact) => {
      if(!contact.email) {
        return acc;
      }

      let key = contact.email;
      if (!acc[key]) {
        acc[key] = new CollectionList('id');
        this.count++;
      }
      acc[key].add(contact);

      return acc;
    }, {});
  }

  /**
   * Checks the list of objects by removing the
   * index that has no duplicate records
   *
   * @return {void}
   */
  removeNonDuplicates() {
    for (let email in this.duplicates) {
      if (this.duplicates[email].count <= 1) {
        this.removeEmailFromDuplicates(email)
      }
    }
  }

  /**
   * Remove email from duplicates
   *
   * @param {String} email
   */
  removeEmailFromDuplicates(email){
    delete this.duplicates[email];
    this.count--;
  }

  /**
   * Remove a list contact ids from object duplicates
   *
   * @param {Array} contact_ids
   * @param {String} email_selected
   *
   * @return {void}
   */
  removeSelectedContactDuplicates(contact_ids, email_selected){
    contact_ids.forEach(index_id => {
      this.duplicates[email_selected].delete(index_id);
    });

    if(this.duplicates[email_selected].count === 0){
      this.removeEmailFromDuplicates(email_selected);
    }
  }
}